/**
 * this is dynamic deal rail card component
 *
 * @module views/components/DynamicDealCardRail
 * @memberof -Common
 */

import React from 'react';

import PropTypes from 'prop-types';

import { spreadProps } from '@ulta/core/utils/dom/dom';

import CompactDealRail from '@ulta/components/CompactDealRail/CompactDealRail';

/**
 * Represents a DynamicDealCardRail component
 *
 * @method
 * @param { DynamicDealCardRailProps} props - React properties passed from composition
 * @returns DynamicDealCardRail
 */
export const DynamicDealCardRail = function( props ){

  if( !props.items ){
    return null;
  }

  return (
    <div className='DynamicDealCardRail'>
      <CompactDealRail { ...spreadProps( { ...props } ) } />
    </div>
  );
};

/**
 * Property type definitions
 * @typedef DynamicDealCardRailProps
 * @type {object}
 * @property {string} example - refactor or delete
 */
export const propTypes =  {
  items: PropTypes.array
};


DynamicDealCardRail.propTypes = propTypes;

export default DynamicDealCardRail;
